export enum ConfigState {
    Pending = 'Pending', // The account has not yet been configured
    Added = 'Added', // The account has been added by the user
    Removed = 'Removed', // The account was removed by the user
    Disabled = 'Disabled', // The account has been disabled because multiple accounts are not supported
}
